import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSideContent } from '#pplx/frontend/apps/ask/search-side-content/core/ProviderShared.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
// eslint-disable-next-line no-restricted-imports
import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';
const SideCanvasViewer = Dynamic(async () => {
    const { SideCanvasViewer } = await import('#pplx/frontend/apps/ask/canvas/SideCanvasViewer.js');
    return { default: SideCanvasViewer };
});
const SidePDFViewer = Dynamic(async () => {
    const { SidePDFViewer } = await import('#pplx/frontend/apps/ask/search-side-content/content/SidePDFViewer.js');
    return { default: SidePDFViewer };
});
const SideFileViewer = Dynamic(async () => {
    const { SideFileViewer } = await import('#pplx/frontend/apps/ask/search-side-content/content/SideFileViewer.js');
    return { default: SideFileViewer };
});
const CitationSideSheet = Dynamic(async () => {
    const { CitationSideSheet } = await import('#pplx/frontend/apps/ask/search-side-content/content/CitationSideSheet.js');
    return { default: CitationSideSheet };
});
const CheckSourcesSideSheet = Dynamic(async () => {
    const { CheckSourcesSideSheet } = await import('#pplx/frontend/apps/ask/search-side-content/content/CheckSourcesSideSheet.js');
    return { default: CheckSourcesSideSheet };
});
const CouncilResponseSideSheet = Dynamic(async () => {
    const { CouncilResponseSideSheet } = await import('#pplx/frontend/apps/ask/search-side-content/content/CouncilResponseSideSheet.js');
    return { default: CouncilResponseSideSheet };
});
const ClaimsSideSheet = Dynamic(async () => {
    const { ClaimsSideSheet } = await import('#pplx/frontend/apps/ask/search-side-content/content/ClaimsSideSheet.js');
    return { default: ClaimsSideSheet };
});
const DatavizSideSheet = Dynamic(async () => {
    const { DatavizSideSheet } = await import('#pplx/frontend/apps/ask/search-side-content/content/DatavizSideSheet.js');
    return { default: DatavizSideSheet };
});
const ComputerArtifactSideSheet = Dynamic(async () => {
    const { ComputerArtifactSideSheet } = await import('#pplx/frontend/apps/ask/search-side-content/content/ComputerArtifactSideSheet.js');
    return { default: ComputerArtifactSideSheet };
});
const PortfolioTaxLotsSideSheet = Dynamic(async () => {
    const { PortfolioTaxLotsSideSheet } = await import('#pplx/frontend/apps/ask/finance/portfolio/PortfolioTaxLotsSideSheet.js');
    return { default: PortfolioTaxLotsSideSheet };
});
export const SideContent = React.memo(function SideContent() {
    const { tab } = useSideContent();
    return (_jsxs(TabsPrimitive.Root, { value: tab?.name ?? '', className: "h-full bg-base", children: [_jsx(TabsPrimitive.TabsContent, { value: "citations", className: "h-full", children: _jsx(CitationSideSheet, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "canvas", className: "h-full", children: _jsx(SideCanvasViewer, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "pdf", className: "h-full", children: _jsx(SidePDFViewer, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "file_preview", className: "h-full", children: _jsx(SideFileViewer, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "check_sources", className: "h-full", children: _jsx(CheckSourcesSideSheet, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "council_response", className: "h-full", children: _jsx(CouncilResponseSideSheet, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "claims", className: "h-full", children: _jsx(ClaimsSideSheet, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "dataviz", className: "h-full", children: _jsx(DatavizSideSheet, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "computer_artifact", className: "h-full", children: _jsx(ComputerArtifactSideSheet, {}) }), _jsx(TabsPrimitive.TabsContent, { value: "finance_tax_lots", className: "h-full", children: _jsx(PortfolioTaxLotsSideSheet, {}) })] }));
});
//# sourceMappingURL=SideContent.js.map